import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import ProtectedRoutes from './components/protectedRoutes';
import ShowToast from './components/showToast';
import InactivityLogout from './Auth/InactiveLogout';
import 'bootstrap/dist/css/bootstrap.min.css';

const isAuthenticated = () => {
  const token = localStorage.getItem('isAuth');
  return token;
};
const App = () => {
    const [authenticated, setAuthenticated] = useState(isAuthenticated());
    useEffect(() => {
        const checkAuth = () => setAuthenticated(isAuthenticated());
        checkAuth();
      }, []);
      
      return (
      //author-saksham.sharma
      //protected routes, accessable for authorized user only
      <Router>
        <InactivityLogout />
        <ShowToast />
        <div>
            <ProtectedRoutes isAuth={authenticated} />
        </div>
      </Router>)
      //end
};

export default App;